import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ProxyInfo, WebsocketConnection } from "../common.browser/Exports";
import { PropertyId } from "../sdk/Exports";
import { ConnectionFactoryBase } from "./ConnectionFactoryBase";
import { WebsocketMessageFormatter } from "./Exports";
var TestHooksParamName = "testhooks";
var ConnectionIdHeader = "X-ConnectionId";
export var IntentConnectionFactory = /*#__PURE__*/function (_ConnectionFactoryBas) {
  _inherits(IntentConnectionFactory, _ConnectionFactoryBas);

  var _super = _createSuper(IntentConnectionFactory);

  function IntentConnectionFactory() {
    var _this;

    _classCallCheck(this, IntentConnectionFactory);

    _this = _super.apply(this, arguments);

    _this.create = function (config, authInfo, connectionId) {
      var endpoint = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Endpoint);

      if (!endpoint) {
        var region = config.parameters.getProperty(PropertyId.SpeechServiceConnection_IntentRegion);
        endpoint = "wss://speech.platform.bing.com/speech/" + _this.getSpeechRegionFromIntentRegion(region) + "/recognition/interactive/cognitiveservices/v1";
      }

      var queryParams = {
        format: "simple",
        language: config.parameters.getProperty(PropertyId.SpeechServiceConnection_RecoLanguage)
      };

      _this.setCommonUrlParams(config, queryParams, endpoint);

      var headers = {};
      headers[authInfo.headerName] = authInfo.token;
      headers[ConnectionIdHeader] = connectionId;
      return new WebsocketConnection(endpoint, queryParams, headers, new WebsocketMessageFormatter(), ProxyInfo.fromRecognizerConfig(config), connectionId);
    };

    return _this;
  }

  _createClass(IntentConnectionFactory, [{
    key: "getSpeechRegionFromIntentRegion",
    value: function getSpeechRegionFromIntentRegion(intentRegion) {
      switch (intentRegion) {
        case "West US":
        case "US West":
        case "westus":
          return "uswest";

        case "West US 2":
        case "US West 2":
        case "westus2":
          return "uswest2";

        case "South Central US":
        case "US South Central":
        case "southcentralus":
          return "ussouthcentral";

        case "West Central US":
        case "US West Central":
        case "westcentralus":
          return "uswestcentral";

        case "East US":
        case "US East":
        case "eastus":
          return "useast";

        case "East US 2":
        case "US East 2":
        case "eastus2":
          return "useast2";

        case "West Europe":
        case "Europe West":
        case "westeurope":
          return "europewest";

        case "North Europe":
        case "Europe North":
        case "northeurope":
          return "europenorth";

        case "Brazil South":
        case "South Brazil":
        case "southbrazil":
          return "brazilsouth";

        case "Australia East":
        case "East Australia":
        case "eastaustralia":
          return "australiaeast";

        case "Southeast Asia":
        case "Asia Southeast":
        case "southeastasia":
          return "asiasoutheast";

        case "East Asia":
        case "Asia East":
        case "eastasia":
          return "asiaeast";

        default:
          return intentRegion;
      }
    }
  }]);

  return IntentConnectionFactory;
}(ConnectionFactoryBase);